import React from "react";

const AppLogoNoText = () => (
  <div className="app-logo">
    <img src="//www.dvo.com/images/cookn-logo.png" alt="Cook'n" />
  </div>
)

export default AppLogoNoText


// WEBPACK FOOTER //
// ./src/Components/AppLogoNoText.js